import {
  Text,
  useZustandModalKitStore,
  EModalTypes,
  zustandModalKitSelector,
  ArrowSvg,
  Image,
} from 'react-gldn-kit';
import { useNavigate } from 'react-router';
import cln from 'classnames';

import { useZustandCasinoDrawerStore } from 'stores/drawers/casino/store';
import { isFullCasinoDrawerSelector } from 'stores/drawers/casino/selectors';
import { DrawerCardTranslate } from 'react-memory-optimization/dist/lib/store/casino/entities/promotions/types';

import { ERouteNames } from 'Routes/types';

import styles from './PromotionBanner.module.css';

type Props = {
  handleClose: (e?: React.MouseEvent<HTMLDivElement>) => Promise<void>;
  bgPath: string;
  translate: DrawerCardTranslate;
};

const PromotionBanner = ({ handleClose, bgPath, translate }: Props) => {
  const isFullView = useZustandCasinoDrawerStore(isFullCasinoDrawerSelector);

  const navigate = useNavigate();

  const closeModal = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const jumpTo = (e: React.MouseEvent<HTMLDivElement>) => {
    handleClose(e);
    closeModal(EModalTypes.Unknown);

    navigate(ERouteNames.InHouseBattles);
  };

  return (
    <div
      className={cln(styles.wrapperPromotionBanner, {
        [styles.short]: !isFullView,
      })}
      onClick={jumpTo}
    >
      {/* <Image path={`${BASE_IMG_URL}${bgPath}`} /> */}
      <Image path={`https://elonbet.com${bgPath}`} classes={styles.img} />

      <div className={styles.content}>
        <div className={styles.title}>
          {/* <Text idT="bigGive.button" /> */}
          <Text idT={translate.title} />
        </div>

        <div className={styles.moreDetailed}>
          <div>
            <Text idT={translate.button} />
          </div>
          <ArrowSvg classes={styles.arrowSvg} width={16} height={9} />
        </div>
      </div>
    </div>
  );
};

export default PromotionBanner;
